import React, { createContext, useMemo, useState } from 'react';
import {
  TPaymentContext,
  TPaymentContextProvider,
} from './PaymentContextTypes';

export const PaymentContext = createContext<TPaymentContext | null>(null);
export const PaymentContextProvider = ({
  children,
}: TPaymentContextProvider) => {
  const [authenticationKey, setAuthenticationKey] = useState('');
  const [disableFormSubmit, setDisableFormSubmit] = useState(false);
  const [closeHostedForm, setCloseHostedForm] = useState(false);
  const [token, setToken] = useState('');
  const [transactionId, setTransactionId] = useState('');

  const providerValue = useMemo(
    () => ({
      authenticationKey,
      setAuthenticationKey,
      disableFormSubmit,
      setDisableFormSubmit,
      closeHostedForm,
      setCloseHostedForm,
      token,
      setToken,
      transactionId,
      setTransactionId,
    }),
    [
      authenticationKey,
      disableFormSubmit,
      closeHostedForm,
      token,
      transactionId,
    ]
  );

  return (
    <PaymentContext.Provider value={providerValue}>
      {children}
    </PaymentContext.Provider>
  );
};
